import apiUrl from '../../../constants'
import axios from 'axios'
import {
	Validator
} from 'vee-validate'
import moment from 'moment'
import VueElementLoading from 'vue-element-loading';
import CryptoJS from 'crypto-js';
import utils from '../../../utils/validateScanner';
import user_tracker from '../../../usertracker'

export default {
	name: 'PrintForwardSticker',
	mixins: [utils],
	components: {
		VueElementLoading
	},
	data: function() {
		return {
			barcode:'',
			shipmentData:[],
			userData:[],
			isLoading: false,
			showTable:false,
			prnData: '',
			userHubId: 0,
			createdby:'',
			shippingIdForColor:'',
			isDisabled: false,
		}
	},
	created: function() {},
	model: {
	},
	computed: {
	},
  filters: {
    moment: function(date) {
      if (date == '' || date == null) {
        return '--'
      }
      return moment(date).format('DD-MM-YYYY HH:mm:ss');
    }
  },
	mounted() {
		this.$refs.barcode.focus();
		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext)
		this.userData = userdetail;
		this.userHubId = userdetail[0].HubId[0] == undefined ? 0 : userdetail[0].HubId[0];
		this.createdby = userdetail[0].email;

		var userTokenEncrypt = window.localStorage.getItem('userToken')
		var userTokenDecrypt = CryptoJS.AES.decrypt(userTokenEncrypt.toString(), 'Key');
		var userToken = userTokenDecrypt.toString(CryptoJS.enc.Utf8);
		this.token = JSON.parse(userToken)

		var permissionEncrypt = window.localStorage.getItem('permissiondata')
		var bytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var permissiondata = JSON.parse(plaintext);

		for (let i = 0; i < permissiondata.length; i++) {
			let data = permissiondata[i];
			let menuItem = data.name.replace(/\s+/g, '').toLowerCase();
			if (menuItem === "printforwardsticker") {
				const printLabelUrl = process.env.NODE_ENV === 'production'
					? 'https://lastmileallocationpod-app.xbees.in/#/PrintLabelv2'
					: 'https://lastmileallocationpod-appstage.xbees.in/#/PrintLabelv2';
				window.open(printLabelUrl, '_blank');
				this.isDisabled = true;
				break;
			}
		}

	},


	methods: {
		resetData(){
			this.barcode='',
			this.shipmentData='',
			this.showTable=false,
			this.isLoading=false,
			this.prnData = '',
			this.token = '',
			this.$refs.barcode.focus(),
			this.$validator.reset();
      this.errors.clear();
	  this.showHideCodeIconInput();
		},

		showdetails(){
			this.$validator.validateAll().then((result) => {
        if (result) {
					this.shipmentData=[]; this.prnData='';
					this.showTable=false; this.isLoading=true;
					this.input = {
								"ShippingId": this.barcode,
								"CurrentHubID": this.userHubId
					}
					axios({
							method: 'GET',
							url: apiUrl.api_url_hubops + 'getShipmentDetailsForFWDSlip' + "?ShippingId=" + this.barcode + "&CurrentHubID=" + this.userHubId,
							headers: {
								'authorization': 'authkey xB84JJ89Hd25',
                'token': this.token
							}
						})
						.then(result => {
							if (result.data.ResultCode == 100) {
								if(Object.keys(result.data.lossCategorization).length !=0){
									this.shippingIdForColor=this.barcode; 
									this.showHideCodeIconInput(result.data.lossCategorization.colorCode, result.data.lossCategorization.icon);
								}
								this.shipmentData=result.data.ResponseData[0];

                this.prnData = `^XA
									^SZ2^JMA
									^MCY^PMN
									^PW812
									~JSN
									~SD25^MD0
									^JZY
									^LH0,0^LRN
									^XZ
									^XA
									^FO3,66
									^GB803,0,3^FS
									^FO2,135
									^GB805,0,3^FS
									^FO3,241
									^GB803,0,3^FS
									^FO3,343
									^GB803,0,3^FS
									^FO3,444
									^GB803,0,3^FS
									^FO3,525
									^GB803,0,3^FS
									^FO400,68
									^GB0,66,3^FS
									^FO180,242
									^GB0,205,3^FS
									^FO135,448
									^GB0,77,3^FS
									^FO393,448
									^GB0,77,3^FS
									^FO504,448
									^GB0,77,3^FS
									^FO215,525
									^GB0,60,3^FS
									^FO361,525
									^GB0,60,3^FS
									^FT20,35
									^CI0
									^A0N,38,30^FDXPRESSBEES^FS
									^FT115,57
									^A0N,17,23^FDDelivering Happiness^FS
									^FT465,36
									^A0N,17,23^FDPrinted By^FS
									^FT465,57
									^A0N,17,23^FD${this.createdby.split('@')[0]}^FS
									^FT712,54
									^A0N,45,30^FDFWD^FS
									^FT21,118
									^A0N,42,30^FDDelivery Type : ${this.shipmentData.OrderType}^FS
									^FT450,118
									^A0N,42,30^FD${this.shipmentData.ProcessCode}^FS
									^FO50,149
									^BY2^BCN,53,N,N^FD>:${this.shipmentData.ShippingID}^FS
									^FT50,229
									^A0N,25,27^FD${this.shipmentData.ShippingID}^FS
									^FT20,283
									^A0N,30,20^FDCust Name :-^FS
									^FT20,327
									^A0N,30,20^FDCust Address :-^FS
									^FT190,275
									^A0N,20,25^FD${this.shipmentData.CustomerName}^FS
									^FT190,310
									^A0N,20,20^FD${this.shipmentData.CustomerAddress1}^FS
									^FT190,335
									^A0N,20,20^FD${this.shipmentData.CustomerAddress2}^FS
									^FT20,385
									^A0N,30,20^FDRTO Name :-^FS
									^FT20,430
									^A0N,30,20^FDRTO Address :-^FS
									^FT190,377
									^A0N,20,25^FD${this.shipmentData.destiRtoHubName}^FS
									^FT190,413
									^A0N,20,20^FD${this.shipmentData.RTOAddress1}^FS
									^FT190,438
									^A0N,20,20^FD${this.shipmentData.RTOAddress2}^FS
									^FT20,480
									^A0N,30,20^FDDestination^FS
									^FT20,516
									^A0N,30,20^FDHub :-^FS
									^FT145,510
									^A0N,34,30^FD${this.shipmentData.destinationhubname}^FS
									^FT410,481
									^A0N,30,20^FDClient^FS
									^FT410,511
									^A0N,30,20^FDName :-^FS
									^FT517,511
									^A0N,34,30^FD${this.shipmentData.clientName}^FS
									^FT20,565
									^A0N,30,20^FDDelivery Pincode :-^FS
									^FT228,565
									^A0N,28,38^FD${this.shipmentData.CustomerPinCode}^FS
									^PQ1,0,1,Y
									^XZ`;

								 this.showTable= result.data.showlientDetailsForFwd ? false : true ;
								 user_tracker.checkUserIP(this.userData[0], "PrintForwardSticker", this.$route.path , this.input);
								 if(this.prnData){ this.printerSticker(); }
                 this.isLoading=false;
							} else if (result.data.ResultCode!=100) {
								this.showTable=false;
								this.$alertify.error(result.data.ReturnMessage)
                this.isLoading=false;
							}
						}, error => {
							this.isLoading=false;
							console.error(error)
						})
					}
				});
		},

		printerSticker() {

		 this.loginput = {
			CurrentHubID:    this.userHubId,
			FlyerShippingId: this.barcode,
			PrintedBy:       this.createdby,
			PrintedDate:     moment().format('YYYY-MM-DD HH:mm:ss'),
			Status:          'printFailed',
			PrintedFrom :    "HubOps",
			source :         'Web'
		 }
 		 this.input = {
 			 prnData: this.prnData,
 			 bagNumber: moment().format('DD-MM-YYYY')
 		 }

 		 axios({
			 method: "POST",
			 url: "http://localhost:4500/printer/printbagsticker",
			 data: this.input,
		 })
		 .then(result => {
				if (result.data.ResultCode == 100) {
					this.loginput.Status = 'printDone';
					this.$alertify.success('Print Generated Successfully');
					this.addStickerLog(this.loginput);
				} else {
					this.$alertify.error(result.data.ReturnMessage);
					this.addStickerLog(this.loginput);
				}
				this.isLoading=false;
		 }, error => {
			var code = error.response == undefined ? code = 0 : error.response.status;
			if (code == 500) {
				this.$alertify.error("Printer API error");
			} else if (error) {
				this.$alertify.error("Printer not connected")
			}
			this.isLoading = false;
			this.addStickerLog(this.loginput);
		 })
 	 },

	 addStickerLog(input) {
		 axios({
			 method: "POST",
			 url: apiUrl.api_url_hubops + 'addRtoDtoStickerLogs',
			 data: input,
			 headers: {
				 'authorization': 'authkey xB84JJ89Hd25'
			 }
		 })
		 .then(result => {
			 if (result.data.ResultCode == 100) {
				 this.$alertify.success('Log Created Successfully');
				 this.barcode = "";
				 this.$refs.barcode.focus()
				 this.$validator.reset();
				 this.errors.clear();
			 }else{
				 this.$alertify.error(result.data.ReturnMessage);
			 }
		 }, error => {
			 this.$alertify.error(error.message);
		 })
	 }
	},
}



// WEBPACK FOOTER //
// ./src/views/components/PrintForwardSticker/PrintForwardSticker.js